import { DateTimeDTO } from "../../date-time-dto.model";

export class DateTimeHelper {
    public static toDate = (date?: DateTimeDTO | null): Date | null => {
        if (!date) return null;
        return new Date(date.year, date.month - 1, date.day, date.hours, date.minutes, 0, 0);
    } 

    public static toDateTimeDTO = (datePicker?: Date | null, timePicker?: Date | null):DateTimeDTO | null => {
        if (!datePicker) return null;

        return {
            year: datePicker.getFullYear(),
            month: datePicker.getMonth() + 1,
            day: datePicker.getDate(),
            hours: timePicker?.getHours() ?? datePicker.getHours(),
            minutes: timePicker?.getMinutes() ?? datePicker.getMinutes()
        }
    }
}